import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  BONUS_PRICE,
  INTELLIMIZE_COUPON_EVENT,
  LOYALTY_SIGNUP_MODAL,
  NAVITUS,
  PHARMACY_PRICE_LIST_MODAL,
  SOFT_COUPON_MODAL
} from '../../../constants/defaults';
import CouponModal from '../CouponModal/index.jsx';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import GeniusR from '../GeniusR';
import loadable from '@loadable/component';
import { useDispatch, useSelector } from 'react-redux';
import { modalActions } from '../../../reducers/modalSlice';
import { AuthContext } from '../../../Contexts';
import GetFreeCoupon from '../../common/GetFreeCoupon/index';
import {
  addToWallet,
  fetchCouponData
} from '../../../services/Api/Coupon/CouponService.js';
import Image from '../../common/Image.jsx';
import SendContact from '../SendContactAB/index.jsx';
const AuthenticateModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);

const TieredPricingListItem = props => {
  const {
    drugData,
    drugName,
    geniusRxPrice = false,
    isPricingUpdated = false,
    item = {},
    lowestPrice,
    lowestPricePharmacyName,
    maxPharmacyPosition,
    position = 0,
    selectedDisplayQuantity,
    userPoints,
    drugInformationOverrideSeoName = '',
    expandedCoupon = 1,
    setExpandedCoupon = () => {}
  } = props;
  const [isContactLoading, setContactLoading] = useState(true);
  const [isOpenSignupModal, setIsOpenSignupModal] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isPriceInfoOpen, setIsPriceInfoOpen] = useState(false);
  const [topScroll, setTopScroll] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const wrapperRef = useRef();
  const couponShowHideInfoFunc = useRef(null);
  const context = useContext(AuthContext);
  const isLoggedIn = context?.userData?.isLoggedIn;
  const storeItem = useSelector(state => state.modal.item);
  const modalState = useSelector(state => state.modal.modal);
  const currentCouponData = useSelector(state => state.userDrugs.couponData);
  const { t, i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  const dispatch = useDispatch();
  const [pdfUrl, setPdfUrl] = useState('');
  const [fetchContactError, setFetchContactError] = useState(false);
  const [hiddenParams, setHiddenParams] = useState({});
  const [isHoverActive, setIsHoverActive] = useState(false);
  const [isOpenABModal, setIsOpenABModal] = useState(false);
  const [bottomSheetState, setBottomSheetState] = useState({
    isTextEmailCoupon: false,
    isAddToWallet: false,
    isExpandCoupon: false
  });
  const [sendType, setSendType] = useState('');
  const [isWalletUrlLoading, setIsWalletUrlLoading] = useState(false);
  const [contactSent, updateContactSent] = useState(false);
  const cheapestPrices = item.Prices[0];
  const isAndroid =
    typeof window !== 'undefined' &&
    /(android)/i.test(window.navigator.userAgent);
  let allowCouponABTest = position === 1 && props.isMobileDevice && !isEs;
  let cheapestPrice = { ...item.Prices[0] };
  let eventObj = {
    memberBalance: userPoints,
    drugName: drugData.name,
    seoName: drugData.seoName,
    NDC: drugData.ndc,
    drugBrand: drugData?.drugType
      ? drugData?.drugType
      : drugData.isGeneric
      ? 'generic'
      : 'brand',
    drugForm: drugData.form,
    drugDosage: drugData.dosage,
    drugQuantity: drugData.quantity,
    drugQuantityUnit: 'count',
    pbm: cheapestPrices.pBAName,
    pharmacyPrice: cheapestPrices.Price,
    priceUsualAndCustomary: cheapestPrices.UsualAndCustomary,
    singlecarePrice: cheapestPrices.Price,
    lowestPrice: lowestPrice,
    lowestPricePharmacyName: lowestPricePharmacyName,
    loyaltyApplicable: cheapestPrices.LoyaltyApplicable,
    loyaltyBonusSavings: cheapestPrices.LoyaltyBonusSavings,
    loyaltyExcluded: cheapestPrices.LoyaltyExcluded,
    loyaltyPrice: cheapestPrices.LoyaltyPrice,
    maxPharmacyPosition: maxPharmacyPosition,
    GPI: drugData.gpi,
    network: item.Pharmacy.network,
    pharmacyNetPrice: cheapestPrices.LoyaltyPrice,
    memberSavings: !_.isEmpty(cheapestPrices.LoyaltyDiscounts)
      ? cheapestPrices.LoyaltyDiscounts[0].discountAmount
      : '',
    bonusSavings: cheapestPrices.LoyaltyBonusSavings
  };
  const currentPrice = cheapestPrice.LoyaltyPrice;
  let discountAmount =
    !_.isEmpty(cheapestPrice.LoyaltyDiscounts) &&
    cheapestPrice.LoyaltyDiscounts[0].discountAmount;

  const isLoyaltyBonusSavingsEmpty =
    cheapestPrice.LoyaltyBonusSavings === '0.00' ||
    cheapestPrice.LoyaltyBonusSavings === '';

  const isSignupLabelShow =
    discountAmount != '0.00' || !isLoyaltyBonusSavingsEmpty;

  cheapestPrice.PharmacyName = item.Pharmacy.Name;
  const showExclusive =
    !_.isEmpty(cheapestPrice.ExclusivePriceDetails) &&
    !cheapestPrice.ExclusivePriceDetails.ShowsExclusivePriceAsBaselinePrice;
  const parentClass =
    'pharmacy-item__5off pharmacy-item' +
    (showExclusive ? ' pharmacy-item-offer' : '');
  const isUserLoggedIn = isLoggedIn || isLogin;
  const isOpenIndex = expandedCoupon === position;

  const handleClickOutside = event => {
    if (
      wrapperRef &&
      !_.isNull(wrapperRef.current) &&
      !wrapperRef.current.contains(event.target) &&
      typeof event.target.className != 'object' &&
      !event.target.className.includes('active')
    ) {
      setIsPriceInfoOpen(false);
      couponShowHideInfoFunc.current();
    }
  };

  useEffect(() => {
    setIsLogin(isLoggedIn);
    if (isPricingUpdated && position === maxPharmacyPosition) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('drug-list-updated'));
      }, 1000);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isPricingUpdated, position, maxPharmacyPosition]);

  useEffect(() => {
    if (isPricingUpdated && position === maxPharmacyPosition) {
      props.setIsPricingUpdated(false);
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('drug-list-updated'));
      }, 1000);
    }
    document.body.classList.toggle(
      'blockScroll',
      isModalOpen || showSignupModal
    );
    if (_.getIsMobileDevice()) {
      document.body.style.position = isModalOpen ? 'fixed' : '';
    }
  }, [isModalOpen, showSignupModal]);

  useEffect(() => {
    document.body.classList.toggle('blockScroll', isOpenABModal);
  }, [isOpenABModal]);

  useEffect(() => {
    if (
      position === 1 &&
      props?.isMobileDevice &&
      !_.isEmpty(drugData) &&
      window?.allowFetchCouponAPICall
    ) {
      fetchContactData();
    }
  }, [drugData]);

  // Fetch Coupon Data
  const fetchContactData = async () => {
    await setContactLoading(true);
    try {
      const { PartnerUser, PartnerPassword } = item.Prices[0];
      const contactResponse = await fetchCouponData(
        PartnerUser,
        PartnerPassword,
        '65',
        {},
        drugData.seoName,
        cheapestPrice.Price,
        cheapestPrice.LoyaltyApplicable,
        cheapestPrice.LoyaltyExcluded,
        cheapestPrice.LoyaltyBonusSavings,
        cheapestPrice.preferredNdc
      );
      if (!_.isEmpty(contactResponse.PDFUrl))
        await setPdfUrl(contactResponse.PDFUrl);
      else await setFetchContactError(true);
      if (!_.isEmpty(contactResponse)) {
        setHiddenParams({
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN
        });
        let finalEventObj = {
          ...eventObj,
          event: 'couponPreviewGenerated',
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN,
          geniusRxPrice
        };
        _.triggerGTMVirtualPageViewEvent(finalEventObj);
      }
    } catch (err) {
      console.log(err);
      setFetchContactError(true);
    } finally {
      await setContactLoading(false);
    }
  };

  const onFreeCouponClick = (e, item, position) => {
    localStorage.setItem(
      'couponVariation1',
      JSON.stringify({
        ...item,
        position,
        drugData,
        selectedDisplayQuantity,
        lowestPrice,
        lowestPricePharmacyName,
        maxPharmacyPosition,
        userPoints,
        doNotMarket: props.doNotMarket,
        geniusRxPrice
      })
    );
    !window?.allowFullScreenCouponPage && setIsModalOpen(true);
    let finalEventObj = {
      ...eventObj,
      event: 'getFreeCouponClick',
      pharmacyName: item?.Pharmacy?.Name,
      pharmacyPosition: position,
      pharmacyDistance: item?.Pharmacy?.Distance,
      clickText: e?.target?.textContent,
      network: item?.Pharmacy?.network,
      couponPreview:
        e?.target?.textContent === 'Expand free coupon' ? 'yes' : 'no',
      geniusRxPrice
    };
    _.triggerGTMVirtualPageViewEvent(finalEventObj);
    if (allowCouponABTest && e?.target?.textContent === 'Expand free coupon') {
      _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.GENERATE_COUPON);
      _.sendIntellimizeEvent(
        INTELLIMIZE_COUPON_EVENT.PRESCRIPTION_COUPON_GENERATE
      );
    }
    !isLogin &&
      !window?.allowFullScreenCouponPage &&
      dispatch(modalActions.freeCouponModal({ item }));
  };

  /*
   *  this code is for to open - last open coupon model
   *  here we check if user is from loyalty signup then open,
   *  previous open coupon model after signup/login
   *  */
  useEffect(() => {
    if (
      isLoggedIn &&
      (modalState === LOYALTY_SIGNUP_MODAL ||
        modalState === SOFT_COUPON_MODAL) &&
      !_.isEmpty(storeItem) &&
      item.Pharmacy.Name === storeItem.Pharmacy.Name
    ) {
      onFreeCouponClick(storeItem, position);
    }
  }, [storeItem]);

  useEffect(() => {
    if (
      isLoggedIn &&
      !_.isEmpty(currentCouponData.item) &&
      currentCouponData.item.Pharmacy.Name === item.Pharmacy.Name
    ) {
      setIsModalOpen(true);
    }
  }, [currentCouponData]);

  const parsePriceValue = (cheapestPrice = {}) => {
    return (
      !_.isEmpty(cheapestPrice.ExclusivePriceDetails) &&
      Number(cheapestPrice.Price) +
        (!_.isEmpty(cheapestPrice.ExclusivePriceDetails)
          ? Number(cheapestPrice.ExclusivePriceDetails.Modifier)
          : 0)
    );
  };

  const numberWithCommas = (price = '') => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const openSignupModal = () => {
    setIsOpenSignupModal(true);
    let { signUpPath, signUpPathWithInvite } = _.getSignUpPath(
      PHARMACY_PRICE_LIST_MODAL
    );
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      referralLink: _.getReferralLink(context?.userData?.referralCode),
      ...signUpPathWithInvite
    });
    dispatch(modalActions.priceListSignupModal());
  };

  const closeSignupModal = () => {
    setIsOpenSignupModal(false);
  };

  const showDistance = item => {
    if (item.Pharmacy.onlinePharmacy) {
      return (
        <div className="pharmacy-item__distance">
          <span>{t('Online only')}</span>
        </div>
      );
    }
  };

  const handlePriceInfoTooltip = () => {
    setIsPriceInfoOpen(!isPriceInfoOpen);
  };

  const handlePriceInfoTooltipKB = e => {
    if (e.key === 'Enter') {
      handlePriceInfoTooltip();
    }
  };

  const getSignupSpanProps = () => {
    return {
      onKeyDown: e => {
        if (e.key === 'Enter') {
          openSignupModal();
          handlePriceInfoTooltip();
        }
      },
      onClick: () => openSignupModal(),
      'aria-label': t('sign-up (opens dialog)'),
      role: 'button'
    };
  };

  const addToWalletHandler = async (e, item) => {
    e.preventDefault();
    const { PartnerUser, PartnerPassword, LoyaltyPrice, preferredNdc } =
      item.Prices[0];
    let data = {
      pId: PartnerUser,
      pPass: PartnerPassword,
      contactTypeId: 92,
      drug: drugData?.name,
      pharmacy: item?.Pharmacy?.Name,
      Price: LoyaltyPrice,
      Form: drugData.form,
      dsg: drugData.dosage,
      qty: drugData.quantity,
      isCard: false,
      preferredNdc: preferredNdc
    };
    let sendCouponObj = {
      ...eventObj,
      pharmacyName: item?.Pharmacy?.Name,
      pharmacyPosition: position,
      pharmacyDistance: item?.Pharmacy?.Distance
    };
    let dataLayerEventObj = {
      event: 'addToWallet',
      os: isAndroid ? 'android' : 'ios',
      ndc: preferredNdc,
      ...sendCouponObj,
      ...hiddenParams
    };
    setIsWalletUrlLoading(true);
    let resp = await addToWallet(data);
    if (resp?.Result && resp?.Result?.WalletCouponURL) {
      const walletCouponURL = resp?.Result?.WalletCouponURL;
      if (resp?.Result?.Contact?.MemberNumberFull)
        dataLayerEventObj.authNumber = resp?.Result?.Contact?.MemberNumberFull;
      _.triggerGTMVirtualPageViewEvent(dataLayerEventObj);
      _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.COUPON_ADDEDTOWALLET);
      setIsWalletUrlLoading(false);
      window.location.assign(
        walletCouponURL?.GoogleWallet,
        walletCouponURL?.AppleWallet
      );
    }
  };

  const handleCloseBottomSheetModal = () => {
    setIsOpenABModal(false);
    setBottomSheetState(
      Object.fromEntries(Object.keys(bottomSheetState).map(key => [key, false]))
    );
    updateContactSent(false);
  };

  const handleOpenPharmacy = () => {
    if (isOpenIndex) {
      setExpandedCoupon(null);
    } else {
      setExpandedCoupon(position);
      fetchContactData();
    }
  };

  const handleTextEmailCoupon = type => {
    setSendType(type);
    setBottomSheetState({
      ...bottomSheetState,
      isTextEmailCoupon: true
    });
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      pharmacyName: item?.Pharmacy?.Name,
      pharmacyPosition: position,
      pharmacyDistance: item?.Pharmacy?.Distance,
      event:
        type === 'email' ? 'couponEmailButtonClick' : 'couponTextButtonClick',
      buttonLocation: 'coupon_modal',
      chainCode: item?.Pharmacy?.chainCode
    });
    _.sendIntellimizeEvent(
      type === 'email'
        ? INTELLIMIZE_COUPON_EVENT.COUPON_EMAIL_BUTTON_CLICK
        : INTELLIMIZE_COUPON_EVENT.COUPON_TEXT_BUTTON_CLICK
    );
  };

  const handleShareCoupon = e => {
    setIsOpenABModal(true);
    let finalEventObj = {
      ...eventObj,
      event: 'getFreeCouponClick',
      pharmacyName: item?.Pharmacy?.Name,
      pharmacyPosition: position,
      pharmacyDistance: item?.Pharmacy?.Distance,
      clickText: e?.target?.textContent,
      network: item?.Pharmacy?.network,
      couponPreview:
        e?.target?.textContent === 'Expand free coupon' ? 'yes' : 'no',
      geniusRxPrice
    };
    _.triggerGTMVirtualPageViewEvent(finalEventObj);
    _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.GENERATE_COUPON);
    _.sendIntellimizeEvent(
      INTELLIMIZE_COUPON_EVENT.PRESCRIPTION_COUPON_GENERATE
    );
  };

  const handleExpandCoupon = e => {
    setIsOpenABModal(true);
    setBottomSheetState({
      ...bottomSheetState,
      isExpandCoupon: true
    });
    let finalEventObj = {
      ...eventObj,
      event: 'coupon-expanded',
      pharmacyName: item?.Pharmacy?.Name,
      pharmacyPosition: position,
      pharmacyDistance: item?.Pharmacy?.Distance,
      clickText: e?.target?.textContent,
      network: item?.Pharmacy?.network,
      couponPreview: 'yes',
      geniusRxPrice,
      authNumber: hiddenParams.authNumber,
      grpNumber: hiddenParams.grpNumber,
      bin: hiddenParams.bin,
      pcn: hiddenParams.pcn
    };
    _.triggerGTMVirtualPageViewEvent(finalEventObj);
    _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.COUPON_EXPANDED);
  };

  return item.isGeniusRx && API.ALLOW_HOME_DELIVERY ? (
    <div
      className="loginGeniusRx"
      data-loyaltyapplicable={cheapestPrice.LoyaltyApplicable}
      data-formattedprice={cheapestPrice.formattedPrice}
      data-loyaltyprice={cheapestPrice.LoyaltyPrice}
      data-loyaltybonussavings={cheapestPrice.LoyaltyBonusSavings}
      data-loyaltyexcluded={cheapestPrice.LoyaltyExcluded}
    >
      <GeniusR
        drugName={drugName}
        mailOrderPricings={item}
        selectedDisplayQuantity={selectedDisplayQuantity}
        drugData={drugData}
        lowestPrice={lowestPrice}
        lowestPricePharmacyName={lowestPricePharmacyName}
        isMobileDevice={props.isMobileDevice}
      />
    </div>
  ) : (
    // NOTE: Tiered Pricing API volatile, might be required later.
    // const cheapestPrice = _.find(item.Prices, 'IsCheapest');
    <div
      className={cheapestPrice.pBAName === NAVITUS ? 'pbm2' : 'pbm1'}
      data-loyaltyapplicable={cheapestPrice.LoyaltyApplicable}
      data-formattedprice={cheapestPrice.formattedPrice}
      data-loyaltyprice={cheapestPrice.LoyaltyPrice}
      data-loyaltybonussavings={cheapestPrice.LoyaltyBonusSavings}
      data-loyaltyexcluded={cheapestPrice.LoyaltyExcluded}
    >
      <div id="pharmacyItemContainer" className={parentClass}>
        <input type="hidden" defaultValue={cheapestPrice.LoyaltyApplicable} />
        {isOpenSignupModal && (
          <div className="mainModal afterSignupmodal">
            <div
              className="transparentBg"
              onClick={() => closeSignupModal()}
            ></div>
            <div className="signUpModal">
              <AuthenticateModal
                hideAuthenticateModal={() => closeSignupModal()}
              />
            </div>
          </div>
        )}

        {showExclusive && (
          <div className="pharmacy-item__banner">
            <span className="banner-5off">
              {t('Extra')} ${cheapestPrice.ExclusivePriceDetails.Modifier}{' '}
              {t('off')}
            </span>
          </div>
        )}
        <div className="pharmacy-item__details loyaltyItem">
          <div className="pharmacy-item__meta abTestPharmacy-item__meta">
            <div className="pharmacy-item__location">
              {!_.isEmpty(item.Pharmacy.LogoUrl) ? (
                <div className="pharmcy-item-image">
                  {position < 7 ? (
                    <img
                      data-name={_.lowerCase(item.Pharmacy.Name)}
                      alt={_.getPharmacyALTName(
                        `${drugName} coupon at ${item.Pharmacy.Name}`
                      )}
                      srcSet={item.Pharmacy.LogoUrl}
                      src={item.Pharmacy.LogoUrl}
                      className="pharmacy-item__name"
                      height="35"
                      width="170"
                    />
                  ) : (
                    <>
                      <LazyLoadImage
                        data-name={_.lowerCase(item.Pharmacy.Name)}
                        alt={_.getPharmacyALTName(
                          `${drugName} coupon at ${item.Pharmacy.Name}`
                        )}
                        srcSet={item.Pharmacy.LogoUrl}
                        src={item.Pharmacy.LogoUrl}
                        className="pharmacy-item__name"
                        height="35px"
                        width="170px"
                      />
                      {/* noscript fallback for non-JS users */}
                      <noscript>
                        <img
                          data-name={_.lowerCase(item.Pharmacy.Name)}
                          alt={_.getPharmacyALTName(
                            `${drugName} coupon at ${item.Pharmacy.Name}`
                          )}
                          srcSet={item.Pharmacy.LogoUrl}
                          src={item.Pharmacy.LogoUrl}
                          className="pharmacy-item__name"
                          height="35px"
                          width="170px"
                        />
                      </noscript>
                    </>
                  )}
                </div>
              ) : (
                <h3 className="pharmacy-item__name">{item.Pharmacy.Name}</h3>
              )}
              {showDistance(item)}
            </div>
            <div className="PriceSection">
              <div
                className={`cutPriceNew ${isLogin ? 'loginBonusPrice' : ''}`}
              >
                {item.Prices[0].LoyaltyPrice > 0 &&
                item.Prices[0].LoyaltyPrice !== item.Prices[0].Price
                  ? `$${item.Prices[0].Price}`
                  : null}
              </div>
              <div
                className={`pharmacy-item__price ${
                  isLogin ? 'SignUpbonusPrice' : 'bonusPrice'
                }`}
              >
                {_.isEmpty(cheapestPrice.ExclusivePriceDetails) && (
                  <span className="pharmacy-item__price">
                    <b> $ </b>
                    {Number(currentPrice) > 1000
                      ? numberWithCommas(_.round(Number(currentPrice)))
                      : Number(currentPrice).toFixed(2)}
                  </span>
                )}
                {!_.isEmpty(cheapestPrice.ExclusivePriceDetails) && (
                  <span
                    className={
                      showExclusive ? 'price-promo' : 'pharmacy-item__price'
                    }
                  >
                    <b>$</b>
                    {cheapestPrice.ExclusivePriceDetails
                      .ShowsExclusivePriceAsBaselinePrice
                      ? Number(parsePriceValue(cheapestPrice)) > 1000
                        ? numberWithCommas(
                            _.round(Number(parsePriceValue(cheapestPrice)))
                          )
                        : Number(parsePriceValue(cheapestPrice)).toFixed(2)
                      : Number(currentPrice) > 1000
                      ? numberWithCommas(_.round(Number(currentPrice)))
                      : Number(currentPrice).toFixed(2)}
                  </span>
                )}

                <div className="priceWrapper">
                  {isUserLoggedIn &&
                    cheapestPrice.LoyaltyApplicable &&
                    cheapestPrice.LoyaltyBonusSavings != '0.00' && (
                      <React.Fragment>
                        <button
                          className={`infoIcon ${topScroll && 'hoverSelected'}`}
                          aria-label={t('How is this calculated')}
                          aria-describedby={`${_.createIDFromPharmacyName(
                            cheapestPrice.PharmacyName
                          )}-list-info-tooltip`}
                          onMouseLeave={() => setIsHoverActive(false)}
                          onMouseEnter={() => setIsHoverActive(true)}
                          onClick={() => {
                            handlePriceInfoTooltip();
                          }}
                        >
                          <div>
                            <span
                              role="tooltip"
                              className={`infoImage ${
                                (isPriceInfoOpen || isHoverActive) && 'active'
                              }`}
                              onKeyDown={e => handlePriceInfoTooltipKB(e)}
                              onMouseOver={e => {
                                setTopScroll(
                                  _.getIsMobileDevice()
                                    ? e.clientY < 230
                                    : e.clientY < 271
                                );
                              }}
                              aria-label={t('Open pricing info')}
                            ></span>
                            <ul
                              id={`${_.createIDFromPharmacyName(
                                cheapestPrice.PharmacyName
                              )}-list-info-tooltip`}
                              role="status"
                              ref={wrapperRef}
                              className={`visually-hidden ${
                                isPriceInfoOpen || isHoverActive
                                  ? 'visually-visible'
                                  : ''
                              }`}
                              onMouseEnter={() => setIsHoverActive(true)}
                              onMouseLeave={() => setIsHoverActive(false)}
                            >
                              <li>
                                <p className="tooltipHeading">
                                  {t('How is this calculated')}
                                </p>
                              </li>
                              <li className="priceDetails">
                                <p>{t('Non-member price')}:</p>
                                <p className="totalPrice">
                                  ${cheapestPrice.Price}
                                </p>
                              </li>
                              <li className="priceDetails">
                                <p>{t('Your bonus savings')}:&nbsp;</p>
                                <p className="totalPrice">
                                  -${cheapestPrice.LoyaltyBonusSavings}
                                </p>
                              </li>
                              {discountAmount != '0.00' && (
                                <li className="priceDetails">
                                  <p>{t('Members discount')}:</p>
                                  <p className="totalPrice">
                                    -${discountAmount}
                                  </p>
                                </li>
                              )}
                              <li className="priceDetails totalDetail">
                                <p>{t('Your price')}:&nbsp;</p>
                                <p className="totalPrice mainPrice">
                                  ${currentPrice}
                                </p>
                              </li>
                              <li>
                                <p className="savingNote">
                                  {t('Bonus savings apply automatically')}
                                </p>
                              </li>
                            </ul>
                          </div>
                        </button>

                        <div className="bonusSavingInfo">
                          <span>{t('with bonus savings')}</span>
                        </div>
                      </React.Fragment>
                    )}
                  {!isUserLoggedIn && isSignupLabelShow && (
                    <React.Fragment>
                      <span
                        className="signUpLabel themeFocus"
                        onMouseLeave={() => setIsHoverActive(false)}
                      >
                        <button
                          tabIndex="0"
                          onKeyDown={e => handlePriceInfoTooltipKB(e)}
                          className={`infoIcon ${topScroll && 'hoverSelected'}`}
                          aria-label={t('How is this calculated')}
                          aria-describedby={`${_.createIDFromPharmacyName(
                            cheapestPrice.PharmacyName
                          )}-list-info-tooltip`}
                          onMouseEnter={() => setIsHoverActive(true)}
                        >
                          <div>
                            <span
                              role="tooltip"
                              className={`infoImage ${
                                (isPriceInfoOpen || isHoverActive) && 'active'
                              }`}
                              onKeyDown={e => handlePriceInfoTooltipKB(e)}
                              aria-describedby={`${_.createIDFromPharmacyName(
                                cheapestPrice.PharmacyName
                              )}-list-info-tooltip`}
                              onMouseOver={e => {
                                setTopScroll(
                                  _.getIsMobileDevice()
                                    ? e.clientY < 230
                                    : e.clientY < 271
                                );
                              }}
                              onClick={() => {
                                handlePriceInfoTooltip();
                              }}
                              aria-label={t('Open pricing info')}
                            ></span>
                            <ul
                              role="status"
                              id={`${_.createIDFromPharmacyName(
                                cheapestPrice.PharmacyName
                              )}-list-info-tooltip`}
                              ref={wrapperRef}
                              className={`visually-hidden ${
                                isPriceInfoOpen || isHoverActive
                                  ? 'visually-visible'
                                  : ''
                              }`}
                              onMouseEnter={() => setIsHoverActive(true)}
                              onMouseLeave={() => setIsHoverActive(false)}
                            >
                              <li>
                                <p className="tooltipHeading">
                                  {t('How is this calculated')}
                                </p>
                              </li>
                              <li className="priceDetails">
                                <div className="priceLabel">
                                  {t('Price if you don’t')} {t('sign-up-info')}:
                                </div>
                                <div className="totalPrice">
                                  ${cheapestPrice.Price}
                                </div>
                              </li>
                              <li className="priceDetails">
                                <div className="priceLabel">
                                  {t('One-time sign-up bonus')}:&nbsp;
                                </div>
                                <div className="totalPrice">
                                  -${Number(BONUS_PRICE).toFixed(2)}
                                </div>
                              </li>
                              {discountAmount != '0.00' && (
                                <li className="priceDetails">
                                  <div className="priceLabel">
                                    {t('Members discount')}:
                                  </div>
                                  <div className="totalPrice">
                                    -${discountAmount}
                                  </div>
                                </li>
                              )}
                              <li className="priceDetails totalDetail">
                                <div className="priceLabel">
                                  {t('Price with free sign-up')}:&nbsp;
                                </div>
                                <div className="totalPrice mainPrice">
                                  ${currentPrice}
                                </div>
                              </li>
                              <li>
                                <div className="savingNote">
                                  {t('Bonus savings apply automatically')}
                                </div>
                              </li>
                              <li
                                className="signUpButton"
                                tabIndex={
                                  isPriceInfoOpen || isHoverActive ? '0' : '-1'
                                }
                                {...getSignupSpanProps()}
                              >
                                {t('Sign up for free label')}
                              </li>
                            </ul>
                          </div>
                          <span
                            tabIndex="0"
                            className="signUpEnable themeFocus"
                            {...getSignupSpanProps()}
                          >
                            {t('With Member Bonus')}
                          </span>
                        </button>
                      </span>
                      <span
                        className="signUpOff themeFocus"
                        tabIndex="0"
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            openSignupModal();
                          }
                        }}
                        onClick={() => openSignupModal()}
                      >
                        ${BONUS_PRICE} off with&nbsp;
                        <span className="signUpText">signup</span>
                      </span>
                      <span className="signUpWrap themeFocus">
                        with&nbsp;
                        <span
                          className="signUpText"
                          tabIndex="0"
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              openSignupModal();
                            }
                          }}
                          onClick={() => openSignupModal()}
                        >
                          signup
                        </span>
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            {!isEs && (
              <button
                className="chevronIcons themeFocus"
                onClick={handleOpenPharmacy}
              >
                <img
                  src={`${
                    isOpenIndex
                      ? '/content/images/icons/ab-test-chevron-up.svg'
                      : '/content/images/icons/ab-test-chevron-down.svg'
                  }`}
                  alt=""
                />
              </button>
            )}
          </div>

          {allowCouponABTest && !isEs && (
            <div className="couponMainWrapperExp">
              <div className="textCenter pharmacyNote">
                {t('Show these discount codes to your pharmacist.')}
              </div>
              {isContactLoading ? (
                <div className="loaderContainer">
                  <img
                    src="/content/images/loader/loading.gif"
                    alt={t('Coupon card loading')}
                    className="couponLoader"
                  />
                </div>
              ) : fetchContactError ? (
                <div className="errorCardImgMain">
                  <h4>{t('ErrorHead')}</h4>
                  <p>{t('ErrorPara1')}</p>
                  <p>{t('ErrorPara2')}</p>
                </div>
              ) : (
                <>
                  <div className="flexContentVar1">
                    <div
                      className="couponCard"
                      data-bin={hiddenParams?.bin}
                      data-pcn={hiddenParams?.pcn}
                      data-groupnumber={hiddenParams?.grpNumber}
                      data-authnumber={hiddenParams?.authNumber}
                      data-pharmacyname={item.Pharmacy.Name}
                      data-logourl={item.Pharmacy.LogoUrl}
                    >
                      {pdfUrl && (
                        <Image
                          imageUrl={pdfUrl}
                          imageAlt={t('discount-card-param', {
                            pharmacy: _.getPharmacyALTName(item.Pharmacy.Name)
                          })}
                          imageClass="contactImage"
                          containerClass="imageContainer"
                          loaderClass="couponLoader"
                          loaderalt={t('Coupon card loading')}
                          role="progressbar"
                        />
                      )}
                    </div>
                  </div>
                  <div className="flexContentVar2">
                    <div className="couponTop">
                      <div className="couponTopLeft">
                        <p>
                          <strong>ID</strong> {hiddenParams?.authNumber}{' '}
                        </p>
                        <p>
                          <strong>BIN</strong> {hiddenParams?.bin}{' '}
                        </p>
                      </div>
                      <div className="couponTopRight">
                        <p>
                          <strong>GRP</strong> {hiddenParams?.grpNumber}{' '}
                        </p>
                        <p>
                          <strong>PCN</strong> {hiddenParams?.pcn}{' '}
                        </p>
                      </div>
                    </div>

                    <div className="couponBottom">
                      <span>
                        <LazyLoadImage
                          src="/content/images/icons/singlecareLogoGray.svg"
                          alt=""
                        />
                      </span>
                      <p>This coupon is not insurance.</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          <div className="d-flex linkAction pharmacy-item__cta">
            <div className="fullwidth ctaAb">
              <GetFreeCoupon
                id={`get-coupon-${position}`}
                className={`sc-btn-pink rx-get-this-price themeFocus${
                  allowCouponABTest ? ' i-couponBtn' : ''
                }`}
                onClick={e => onFreeCouponClick(e, item, position)}
                text={t('Get free coupon')}
                aria-label={t('Free coupon for', {
                  pharmacy: _.getPharmacyALTName(item.Pharmacy.Name)
                })}
              />

              {allowCouponABTest && (
                <GetFreeCoupon
                  id={`get-coupon-${position}`}
                  className="sc-btn-pink rx-get-this-price themeFocus i-expandCouponbtn"
                  onClick={e => onFreeCouponClick(e, item, position)}
                  text={t('Expand free coupon')}
                  aria-label={t('Free coupon for', {
                    pharmacy: _.getPharmacyALTName(item.Pharmacy.Name)
                  })}
                />
              )}
            </div>
            {isOpenIndex && !isEs && (
              <div className="showCardsDataInfoAb">
                <p>Show this free card to your pharmacist.</p>
                {isContactLoading ? (
                  <div className="loaderContainer">
                    <img
                      src="/content/images/loader/loading.gif"
                      alt={t('Coupon card loading')}
                      className="couponLoader"
                    />
                  </div>
                ) : (
                  <div className="couponDetailsWrapperAB">
                    <div className="couponDetails">
                      <ul>
                        <li>
                          <label>ID</label>
                          <span>{hiddenParams?.authNumber}</span>
                        </li>
                        <li>
                          <label>GRP</label>
                          <span>{hiddenParams?.grpNumber}</span>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <label>BIN</label>
                          <span>{hiddenParams?.bin}</span>
                        </li>
                        <li>
                          <label>PCN</label>
                          <span>{hiddenParams?.pcn}</span>
                        </li>
                      </ul>
                    </div>
                    <div className="couponImgDetails">
                      <label>
                        <img
                          src="/content/images/header/singlecare-logo-grey.png"
                          alt=""
                          height="24"
                          width="149"
                        />
                      </label>
                      <span>This coupon is not insurance.</span>
                    </div>
                  </div>
                )}
                <div className="abTestButtons">
                  <button className="themeFocus" onClick={handleShareCoupon}>
                    <img src="/content/images/icons/share.svg" alt="" />
                    Share
                  </button>
                  <button className="themeFocus" onClick={handleExpandCoupon}>
                    <img src="/content/images/icons/expand.svg" alt="" />
                    Expand
                  </button>
                </div>
              </div>
            )}
            {isModalOpen && (
              <CouponModal
                item={item}
                drugData={drugData}
                selectedDisplayQuantity={selectedDisplayQuantity}
                handlepFizer={props.handlepFizer}
                isProceedClicked={props.isProceedClicked}
                doNotMarket={props.doNotMarket}
                position={position}
                userPoints={userPoints}
                lowestPrice={lowestPrice}
                lowestPricePharmacyName={lowestPricePharmacyName}
                maxPharmacyPosition={maxPharmacyPosition}
                geniusRxPrice={geniusRxPrice}
                customQuantity={props.customQuantity}
                referralLink={`https://www.singlecare.com/invite/${context?.userData?.referralCode}`}
                couponShowHideInfoFunc={couponShowHideInfoFunc}
                isModalOpen={isModalOpen}
                setModalVisibility={value => setIsModalOpen(value)}
                showSignupModal={showSignupModal}
                setSignupModal={value => setShowSignupModal(value)}
                drugInformationOverrideSeoName={drugInformationOverrideSeoName}
                drugName={drugName}
                pdfUrlFirstPos={pdfUrl}
                hiddenParamsFirstPos={hiddenParams}
              />
            )}
          </div>
        </div>

        <div>
          {isOpenABModal && (
            <div
              className="bottomSheetOverlay"
              onClick={handleCloseBottomSheetModal}
            >
              <div
                className="bottomSheetModal"
                onClick={e => e.stopPropagation()}
              >
                <div className="sheetHeader">
                  <button
                    onClick={handleCloseBottomSheetModal}
                    className="closeModal themeFocus"
                  >
                    <img
                      src="/content/images/icons/sheetCloseIcon.svg"
                      alt=""
                    />
                  </button>
                </div>
                <div className="sheetModalContent">
                  {Object.values(bottomSheetState).every(
                    el => el === false
                  ) && (
                    <div className="shareCouponData">
                      <h4> Share Coupon </h4>
                      <ul>
                        <li
                          onClick={() => handleTextEmailCoupon('text')}
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              setSendType('text');
                              setBottomSheetState({
                                ...bottomSheetState,
                                isTextEmailCoupon: true
                              });
                            }
                          }}
                          tabIndex={0}
                        >
                          <span>
                            <img
                              src="/content/images/icons/sheetMessageIcon.svg"
                              alt=""
                            />
                          </span>
                          <label>Text coupon</label>
                        </li>
                        <li
                          onClick={() => handleTextEmailCoupon('email')}
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              setSendType('email');
                              setBottomSheetState({
                                ...bottomSheetState,
                                isTextEmailCoupon: true
                              });
                            }
                          }}
                          tabIndex={0}
                        >
                          <span>
                            <img
                              src="/content/images/icons/sheetEmailIcon.svg"
                              alt=""
                            />
                          </span>
                          <label>Email coupon</label>
                        </li>
                        {isWalletUrlLoading ? (
                          <li>
                            <img
                              src="/content/images/loader/loading.gif"
                              alt="Coupon card loading"
                              className="couponLoader"
                            />
                          </li>
                        ) : (
                          <li
                            onClick={e => addToWalletHandler(e, item)}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                addToWalletHandler(e, item);
                              }
                            }}
                            tabIndex={0}
                          >
                            <span>
                              <img
                                src="/content/images/icons/sheetWalletIcon.svg"
                                alt=""
                              />
                            </span>
                            <label>
                              Add to {isAndroid ? 'Google Pay' : 'Apple Wallet'}
                            </label>
                          </li>
                        )}
                        <li
                          onClick={() =>
                            setBottomSheetState({
                              ...bottomSheetState,
                              isExpandCoupon: true
                            })
                          }
                          tabIndex={0}
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              setBottomSheetState({
                                ...bottomSheetState,
                                isExpandCoupon: true
                              });
                            }
                          }}
                        >
                          <span>
                            <img
                              src="/content/images/icons/sheetExpandIcon.svg"
                              alt=""
                            />
                          </span>
                          <label>See expanded coupon</label>
                        </li>
                      </ul>
                    </div>
                  )}

                  {bottomSheetState.isTextEmailCoupon && (
                    <div className="shareActionData">
                      <h4>{sendType === 'email' ? 'Email' : 'Text'} Coupon</h4>
                      <SendContact
                        isEmail={sendType === 'email'}
                        drugData={drugData}
                        selectedPrice={cheapestPrice}
                        selectedPharmacyName={item?.Pharmacy?.Name}
                        emailButtonClicked={sendType === 'email'}
                        doNotMarket={props.doNotMarket}
                        selectedDisplayQuantity={selectedDisplayQuantity}
                        handleCloseBottomSheetModal={
                          handleCloseBottomSheetModal
                        }
                        contactSent={contactSent}
                        updateContactSent={updateContactSent}
                        eventObj={{
                          ...eventObj,
                          pharmacyName: item.Pharmacy.Name,
                          pharmacyPosition: position,
                          pharmacyDistance: item.Pharmacy.Distance
                        }}
                        sentMessage={
                          sendType === 'email'
                            ? 'success_msgEmail_sent'
                            : 'success_msgText_sent'
                        }
                      />
                    </div>
                  )}
                  {bottomSheetState.isExpandCoupon && (
                    <div className="expandedCouponData">
                      <ul>
                        <li>
                          <label>Authorization Number</label>
                          <span>{hiddenParams?.authNumber}</span>
                        </li>
                        <li>
                          <label>Bin</label>
                          <span>{hiddenParams?.bin}</span>
                        </li>
                        <li>
                          <label>GRP</label>
                          <span>{hiddenParams?.grpNumber}</span>
                        </li>
                        <li>
                          <label>PCN</label>
                          <span>{hiddenParams?.pcn}</span>
                        </li>
                      </ul>
                      <div className="bottomSCLogo">
                        <span>Provided by</span>
                        <img
                          src="/content/images/header/singlecare-logo-grey.png"
                          alt=""
                          height="24"
                          width="149"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {!_.isEmpty(
          item.Prices[0].ExclusivePriceDetails &&
            item.Prices[0].ExclusivePriceDetails.Description
        ) && (
          <div className="pharmacy-item__pricing-msg">
            {showExclusive &&
              _.map(
                item.Prices[0].ExclusivePriceDetails.Description.split('.'),
                (msgText, id) => {
                  return (
                    <p key={id}>
                      <span>{msgText}</span>
                    </p>
                  );
                }
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TieredPricingListItem;
